<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="mergeDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Merge Branch</div
  >

  <form class="mt-9 flex flex-col" [formGroup]="mergeForm" (ngSubmit)="merge()">
    <ng-select
      #mergeBranchSelect
      [fixNgSelectBottom]="mergeBranchSelect"
      data-cy="mergeBranchSelect"
      class="mt-2 w-96 text-base"
      [items]="branchesList"
      [clearable]="false"
      [searchable]="false"
      (change)="branchChange($event)"
      (keyup.esc)="$event.stopImmediatePropagation(); mergeBranchSelect.blur()"
      (keyup.enter)="
        $event.stopImmediatePropagation(); mergeBranchSelect.blur()
      "
      appendTo="body"
      formControlName="branch"
      placeholder="Branch"
      bindLabel="extraName"
      bindValue="extraId"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.extraName }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.extraName }}</div>
      </ng-template>
    </ng-select>

    <div class="mt-5 flex items-center justify-start text-base">
      <span>To the current branch</span>
      <span class="ml-2 font-semibold">{{
        ref.data.currentBranchExtraName
      }}</span>
    </div>

    <div class="mt-9">
      <button
        data-cy="mergeDialogMergeButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Merge</button
      >

      <button
        data-cy="mergeDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
